<div class="flex h-full flex-col">
  <div class="flex h-1 grow flex-col overflow-y-auto">
    <router-outlet class="hidden"></router-outlet>
  </div>
</div>

<div class="hidden">
  <p-button></p-button>
  <p-dialog></p-dialog>
  <input pInputText />
  <p-table [paginator]="true"></p-table>
  <p-select></p-select>
  <p-toast></p-toast>
  <p-tag></p-tag>
  <p-checkbox></p-checkbox>
  <p-progress-spinner></p-progress-spinner>
  <p-progressbar [value]="0"></p-progressbar>
  <p-selectbutton></p-selectbutton>
  <p-inputnumber></p-inputnumber>
  <textarea pTextarea></textarea>
  <p-tabs></p-tabs>
  <p-tabView></p-tabView>
  <p-fileUpload></p-fileUpload>
  <p-confirmDialog></p-confirmDialog>
  <p-popover></p-popover>
  <p-datepicker></p-datepicker>
  <p-divider></p-divider>
  <p-drawer></p-drawer>
  <p-autocomplete></p-autocomplete>
  <p-accordion value="0">
    <p-accordion-panel value="0">
      <p-accordion-header></p-accordion-header>
      <p-accordion-content></p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
</div>
